<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div *ngIf="mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <!-- <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">
                            <tr>
                                <td >
                                    <audio controls>
                                        <source src="https://drive.google.com/uc?id=1QXZVxualw-zqGGP0d6DlAeLf7gHIIPsY&export=download"
                                            type="audio/mpeg">
                                        Your browser does not support the audio element.
                                    </audio><br /><br />
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">
                                    <i class="fa-solid fa-arrow-left fa-lg"></i>
                                </td>
                            </tr>
                        </div>
                    </td> -->
                    <td style="padding-left:4%;
                    padding-right:4%;
                    padding-top: 5%;
                    padding-bottom: 3%;">
                        <h1 style="color: #5ECE42">Backseat Trader's - Methodology</h1><br />
                        In the context of running an algorithm on the eToro platform, the following terms are used to
                        describe
                        specific
                        features and functions of the trading strategy:
                        <br /><br />
                        <h2>Runs on daily candles:</h2> This term indicates that the algorithm relies on daily
                        candlestick data
                        when
                        executing
                        its trading strategy. Candlestick charts are a popular method of visualising the price movement
                        of
                        financial
                        assets, such as stocks or ETFs, over a specific period. In this case, the algorithm operates on
                        a daily
                        time
                        frame, meaning each candlestick represents the price activity of an asset within a single
                        trading day.
                        These
                        daily candlesticks provide valuable information on the opening, closing, high, and low prices
                        for each
                        day,
                        allowing the algorithm to analyze trends and make informed trading decisions based on this data.
                        <br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(1)" id="DailyCandles"><i class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h2>Absolute momentum quantification mechanism based on 13612 weighted filter:</h2> This feature
                        refers
                        to the
                        algorithm's method of calculating the absolute momentum of a financial asset. Absolute momentum
                        is a
                        measure of
                        an asset's performance over a specific period, typically comparing its current price to a
                        historical
                        price
                        point. The 13612 weighted filter is used to smooth out the price data by applying weights to a
                        window of
                        13,612
                        data points (likely days). This approach helps reduce noise in the data and emphasise the
                        underlying
                        trend,
                        allowing the algorithm to accurately assess an asset's absolute momentum.<br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(2)" id="AbsoluteMomentum"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h2>Relative momentum ranking and weight allocation system:</h2> This component of the algorithm
                        involves ranking
                        assets
                        based on their relative momentum, which is a measure of an asset's performance compared to other
                        assets
                        in a
                        portfolio or a benchmark index. By identifying assets with stronger relative momentum, the
                        algorithm
                        aims to
                        capitalise on their potential for higher returns. The weight allocation system then assigns
                        portfolio
                        weights
                        based on these rankings, with higher weights given to assets with stronger relative momentum.
                        This
                        approach is
                        designed to improve the overall performance of the portfolio by strategically allocating capital
                        to
                        assets that
                        are more likely to outperform their peers.<br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(3)" id="RelativeMomentum"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h2>Support for stock and ETF portfolios:</h2> This feature highlights the algorithm's
                        versatility, as
                        it is
                        designed to
                        work with a range of asset types, including individual stocks and exchange-traded funds (ETFs).
                        This
                        compatibility allows users to create and manage diversified portfolios that include a mix of
                        stocks and
                        ETFs,
                        providing an opportunity to optimise returns while managing risk through
                        diversification.<br /><br />
                        <div style="text-align: center">

                            <a (click)="subBub(4)" id="StockAndEtf"><i class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h2>Support for leveraged & unleveraged accounts:</h2> The algorithm caters to both leveraged
                        and
                        unleveraged
                        trading
                        accounts. Leveraged accounts provide traders with the ability to borrow money from their broker,
                        increasing
                        their buying power and potentially amplifying gains. However, this approach also carries a
                        higher level
                        of risk,
                        as losses can be magnified as well. Unleveraged accounts, by contrast, do not involve borrowing
                        and
                        generally
                        have a lower risk profile. By supporting both types of accounts, the algorithm offers
                        flexibility to
                        suit a
                        range of trading styles and risk tolerances.<br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(5)" id="LeveragedAndUnleveraged"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>

                        </div>
                        <br />
                        <h2>Adjustable rebalance period:</h2> This feature allows users to customise the frequency at
                        which the
                        algorithm
                        rebalances their portfolio. Rebalancing is an essential aspect of portfolio management, as it
                        involves
                        adjusting
                        the weights of assets in a portfolio to maintain the desired risk and return characteristics. An
                        adjustable
                        rebalance period empowers users to choose how often they want to rebalance their portfolio,
                        whether it
                        be daily,
                        weekly, monthly, or any other desired interval. This flexibility enables users to tailor the
                        algorithm's
                        performance to their specific needs and preferences, optimising the trading strategy based on
                        their
                        unique
                        requirements.<br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(6)" id="AdjustableRebalance"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        In summary, the algorithm running on the eToro platform incorporates several advanced features
                        to
                        optimise its
                        trading strategy, including daily candlestick data analysis, absolute and relative momentum
                        calculations,
                        support for various asset types and account structures, and an adjustable rebalance period.
                        These
                        capabilities
                        allow users to create diversified portfolios, strategically allocate capital, and manage risk
                        effectively.
                        <br /><br />
                        <h3>External Resources:</h3><br />
                        <span scrolledTo #scrolledToElement="scrolledTo"></span>
                        <h4>Algorithmic Trading Strategies:</h4>
                        "Unequal participation in the markets is deepening the divide within our communities, and more
                        needs to
                        be done to level the playing field for entrepreneurs and investors of all ages, genders, and
                        race".
                        Adena T. Friedman, Chair and Chief Executive Officer. URL:
                        <a href="https://www.nasdaq.com/articles/algorithmic-trading-strategies-2019-06-07">https://www.nasdaq.com/articles/algorithmic-trading-strategies-2019-06-07</a>



                    </td>
                </tr>
            </table>
        </div>
        <br />
        <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

        <section class="linkedIn">
            <div class="shell">
                <div class="section__content">
                    <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                        rel="noopener noreferrer"><img class="linkedImg"
                            src="../../assets/img/Follow Us on LinkedIn.png" alt="Follow us on LinkedIn" /></a>
                </div>
            </div>
        </section>
    </div>
    <div [class.sticky2-mob-stop]="scrolledToElement.reached" [class.sticky2-mob]="scrolledToElement.notreached">
        <div class="row">
            <div class="col-auto" style="align-items: center;
                    display: grid;margin-left:2%">

                <i [routerLink]="['/']" fragment="bubbles" class="fa-solid fa-arrow-left fa-3x"></i>
            </div>
            <div class="col" style="width: 70%;">
                <audio controls>
                    <source src="https://theapi.backseat-trader.com/Method - Overview.mp3"
                        type="audio/mpeg">
                    Your browser does not support the audio element.
                </audio>

            </div>
            <div class="col-auto" style="align-items: center;
            display: grid;margin-right:2%">

                <i [routerLink]="['/']" class="fa-solid fa-house fa-3x" (click)="removePos()"></i>
            </div>
        </div>

    </div>
</div>

<div *ngIf="!mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">
                <tr>
                    <td>
                        <audio controls>
                            <source
                                src="https://theapi.backseat-trader.com/Method - Overview.mp3"
                                type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio><br /><br />
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center;">
                        <i [routerLink]="['/']" fragment="bubbles" class="fa-solid fa-arrow-left fa-lg"></i>
                    </td>
                </tr>
                <br/>
                <tr>
                    <td>
                        <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">Methodology</span><br/>
                    </td>
                </tr>
        </div>
        </td>
        <td style="width: 79%;
                                    padding-right: 19%;
                                    padding-top: 3%;
                                    padding-bottom: 3%;">
            <!-- <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">Methodology</span><br/> -->
            <h1 style="color: #5ECE42">Backseat Trader's - Methodology</h1><br />
            In the context of running an algorithm on the eToro platform, the following terms are used to describe
            specific
            features and functions of the trading strategy:
            <br /><br />
            <h2>Runs on daily candles:</h2> This term indicates that the algorithm relies on daily candlestick data
            when
            executing
            its trading strategy. Candlestick charts are a popular method of visualising the price movement of
            financial
            assets, such as stocks or ETFs, over a specific period. In this case, the algorithm operates on a daily
            time
            frame, meaning each candlestick represents the price activity of an asset within a single trading day.
            These
            daily candlesticks provide valuable information on the opening, closing, high, and low prices for each
            day,
            allowing the algorithm to analyze trends and make informed trading decisions based on this data. <a
                (click)="subBub(1)" id="DailyCandles"><i class="fa-solid fa-circle-info fa-lg"></i></a> <br /><br />

            <h2>Absolute momentum quantification mechanism based on 13612 weighted filter:</h2> This feature refers
            to the
            algorithm's method of calculating the absolute momentum of a financial asset. Absolute momentum is a
            measure of
            an asset's performance over a specific period, typically comparing its current price to a historical
            price
            point. The 13612 weighted filter is used to smooth out the price data by applying weights to a window of
            13,612
            data points (likely days). This approach helps reduce noise in the data and emphasise the underlying
            trend,
            allowing the algorithm to accurately assess an asset's absolute momentum. <a (click)="subBub(2)"
                id="AbsoluteMomentum"><i class="fa-solid fa-circle-info fa-lg"></i></a><br /><br />

            <h2>Relative momentum ranking and weight allocation system:</h2> This component of the algorithm
            involves ranking
            assets
            based on their relative momentum, which is a measure of an asset's performance compared to other assets
            in a
            portfolio or a benchmark index. By identifying assets with stronger relative momentum, the algorithm
            aims to
            capitalise on their potential for higher returns. The weight allocation system then assigns portfolio
            weights
            based on these rankings, with higher weights given to assets with stronger relative momentum. This
            approach is
            designed to improve the overall performance of the portfolio by strategically allocating capital to
            assets that
            are more likely to outperform their peers. <a (click)="subBub(3)" id="RelativeMomentum"><i
                    class="fa-solid fa-circle-info fa-lg"></i></a><br /><br />



            <h2>Support for stock and ETF portfolios:</h2> This feature highlights the algorithm's versatility, as
            it is
            designed to
            work with a range of asset types, including individual stocks and exchange-traded funds (ETFs). This
            compatibility allows users to create and manage diversified portfolios that include a mix of stocks and
            ETFs,
            providing an opportunity to optimise returns while managing risk through diversification. <a
                (click)="subBub(4)" id="StockAndEtf"><i class="fa-solid fa-circle-info fa-lg"></i></a><br /><br />


            <h2>Support for leveraged & unleveraged accounts:</h2> The algorithm caters to both leveraged and
            unleveraged
            trading
            accounts. Leveraged accounts provide traders with the ability to borrow money from their broker,
            increasing
            their buying power and potentially amplifying gains. However, this approach also carries a higher level
            of risk,
            as losses can be magnified as well. Unleveraged accounts, by contrast, do not involve borrowing and
            generally
            have a lower risk profile. By supporting both types of accounts, the algorithm offers flexibility to
            suit a
            range of trading styles and risk tolerances. <a (click)="subBub(5)" id="LeveragedAndUnleveraged"><i
                    class="fa-solid fa-circle-info fa-lg"></i></a><br /><br />




            <h2>Adjustable rebalance period:</h2> This feature allows users to customise the frequency at which the
            algorithm
            rebalances their portfolio. Rebalancing is an essential aspect of portfolio management, as it involves
            adjusting
            the weights of assets in a portfolio to maintain the desired risk and return characteristics. An
            adjustable
            rebalance period empowers users to choose how often they want to rebalance their portfolio, whether it
            be daily,
            weekly, monthly, or any other desired interval. This flexibility enables users to tailor the algorithm's
            performance to their specific needs and preferences, optimising the trading strategy based on their
            unique
            requirements. <a (click)="subBub(6)" id="AdjustableRebalance"><i
                    class="fa-solid fa-circle-info fa-lg"></i></a>

            <br /><br />
            In summary, the algorithm running on the eToro platform incorporates several advanced features to
            optimise its
            trading strategy, including daily candlestick data analysis, absolute and relative momentum
            calculations,
            support for various asset types and account structures, and an adjustable rebalance period. These
            capabilities
            allow users to create diversified portfolios, strategically allocate capital, and manage risk
            effectively.
            <br /><br />
            <h3>External Resources:</h3><br />
            <h4>Algorithmic Trading Strategies:</h4>
            "Unequal participation in the markets is deepening the divide within our communities, and more needs to
            be done to level the playing field for entrepreneurs and investors of all ages, genders, and race".
            Adena T. Friedman, Chair and Chief Executive Officer. URL:
            <a href="https://www.nasdaq.com/articles/algorithmic-trading-strategies-2019-06-07" target="_blank"
                rel="noopener noreferrer">https://www.nasdaq.com/articles/algorithmic-trading-strategies-2019-06-07</a>

        </td>
        </tr>
        </table>
    </div>
    <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

    <section class="linkedIn">
        <div class="shell">
            <div class="section__content">
                <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                    rel="noopener noreferrer"><img class="linkedImg" src="../../assets/img/Follow Us on LinkedIn.png"
                        alt="Follow us on LinkedIn" /></a>
            </div>
        </div>
    </section>
</div>
</div>